import React, { useMemo } from 'react'
import './ActionButton.scss'
import ReactTooltip from 'react-tooltip'
import { Spinner } from 'components/Loaders/Loaders'
import shortid from 'shortid'

const ActionButton = (props) => {
  const {
    iconClass = '',
    label,
    flex = true,
    className = '',
    tooltip = false,
    hideLabel = false,
    style = 'outer',
    disabled = false,
    children,
    loading,
    onClick,
  } = props

  const toolTipId = useMemo(() => {
    return shortid.generate()
  }, [])

  const handleClick = (e) => {
    e.stopPropagation()
    if (disabled) return
    onClick(e)
  }

  return (
    <div className={`action-button ${flex ? 'flex' : ''} ${className} ${style}`}>
      <span>
        <button
          className={`action-icon ${iconClass} ${style} ${disabled ? 'disabled' : ''}`}
          onClick={handleClick}
          aria-disabled={disabled}
          aria-label={label}
          data-tip={typeof tooltip === 'string' ? tooltip : label}
          data-for={toolTipId}
        >
          {!hideLabel && style === 'inner' && label}
          {children && (
            <div className="inner-wrapper">
              {loading ? <Spinner size="medium" linear themeColor="medium-neutral" /> : children}
            </div>
          )}
        </button>
        {!hideLabel && style === 'outer' && <span className="label">{label}</span>}
        {tooltip && <ReactTooltip effect="solid" id={toolTipId} />}
      </span>
    </div>
  )
}

export default ActionButton

export const ActionButtonGroup = (props) => {
  const { className = '', buttonSize = '', children } = props
  const numChildren = React.Children.toArray(children).length
  return numChildren > 0 ? (
    <div className={'action-button-group flex ' + className + ' ' + buttonSize}>{children}</div>
  ) : null
}
